import * as d3 from 'd3';

const closure = mainApp => {
  mainApp.loadData = function(callback) {
    mainApp.worldMap = require('../resources/worldmap_simple.json');
    mainApp.cities = require('../resources/populations.json');
    mainApp.urban = d3.csvParse(require('../resources/urban.csv'));
    callback();
  };
};

export default closure;
